export default "__VITE_ASSET__DB6lY1E8__"